import { getPaylinksMbeUrl } from "../helpers/urls";

export async function getV2TaxById({ env, storeId, taxId }) {
  try {
    const response = await fetch(`${getPaylinksMbeUrl(env)}/api/v1/tax/${taxId}?storeId=${storeId}`, {
      headers: {
        Accept: "application/json",
      },
    });
    const result = await response.json();

    if (result.errors) {
      throw new Error(result.errors[0]?.message)
    }

    return result;
  } catch (error) {
    console.error('[getV2TaxById] Failed to get Tax:', error);
    return null;
  }
}
